import { render, staticRenderFns } from "./RoofCalSender.vue?vue&type=template&id=2e56052e&scoped=true"
import script from "./RoofCalSender.vue?vue&type=script&lang=js"
export * from "./RoofCalSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56052e",
  null
  
)

export default component.exports